import React from "react";

export default function GameProgress({ dailyItems, slotStates, currentSlot, onSlotClick }) {
  return (
    <div className="progress-bar">
      {dailyItems.map((d) => {
        const state = slotStates[d.slot];
        let dotClass = "progress-dot";
        if (d.slot === currentSlot) dotClass += " active";
        if (state?.status === "won") dotClass += " won";
        else if (state?.status === "lost") dotClass += " lost";
        return (
          <button
            key={d.slot}
            className={dotClass}
            onClick={() => onSlotClick(d.slot)}
            title={`Item ${d.slot}`}
          >
            {d.slot}
          </button>
        );
      })}
    </div>
  );
}
